export default {
  title01: "Jelenlegi időjárás",
  title02: "24 óra",
  title03: "10 napos időjárás-előrejelzés megtekintése",
  title04: "Légminőség-index",
  title05: "Minden információ megtekintése",
  title06: "Napkelte és napnyugta",
  title07: "A hold fázisa",
  title08: "A következő telihold",
  title09: "A következő újhold",
  title10: "NAPpal",
  title11: "ÉJSZAKA",
  title12: "Napkelte",
  title13: "Napnyugta",
  title14: "Holdkelte",
  title15: "Holdnyugta",
  title16: "Forrás",
  title17: "Kezdés",
  title18: "Befejezés",
  title19: "Jelenlegi hely használata",
  title20: "Város keresése",
  title21: "Érzékelt hőmérséklet",
  title22: "Érzékelt hőmérséklet árnyékban",
  title23: "Most",
  title24: "Ma",
  title25: "NAP",
  title26: "HÉTFŐ",
  title27: "KEDD",
  title28: "SZERDA",
  title29: "CSÜTÖRTÖK",
  title30: "PÉNTEK",
  title31: "SZOMBAT",
  title32: "Betöltés...",
  title33: "Most",
  title34: "Óránként",
  title35: "Napi",
  title36: "Nap és Hold",
  title37: "Levegőminőség",
  title38: "Kapcsolat: xlf550402@gmail.com",
  title39: "Adatvédelmi nyilatkozat",
  title40: "Szerzői jog © comfortweather.com 2020 - 2026. Minden jog fenntartva.",
  title41: "Az adatokat szolgáltatja",
  title42: "Max.",
  title43: "Min.",
  title44: "Elfogadom",
  title45:
    "Köszönjük, hogy a ComfortWeather-t választotta! Az Ön törvényes jogainak és érdekeinek védelme érdekében, kérjük, használat előtt olvassa el az ",
  title46: "Adatvédelmi Tájékoztatót",
  title47: " .",
  title48: "",
  title49: "Kapcsolat: xyjph123@gmail.com",
  title50: "Szerzői jog © 24hweather.com 2020 - 2026. Minden jog fenntartva.",
  title51:
    "Köszönjük, hogy a 24hweather-t választotta! Az Ön törvényes jogainak és érdekeinek védelme érdekében, kérjük, használat előtt olvassa el az ",
  title52: "A tartózkodási helye megváltozott. Szeretné frissíteni?",
  title53: "Megerősítés",
  title54: "Mégse",
  title55: "Vissza",
  title56: "Hírek",
  title57: "Időjárás frissítése...",
  title58: "Időjárás frissítve",
  title59: "Összes megtekintése",
  title60: "Szerzői jog © mobi321.com 2020 - 2026. Minden jog fenntartva.",
  title61: "Tegnap",
  title62: "Holnap",
  title63: "15 napos időjárás-előrejelzés megtekintése",
  title64: "A mai részletek",
  title65: "Rahu Kaal",
  title66: "Életmód-indexek",
  title67: "Életmód-indexek",
  title68: "未来7天Rahu Kala时间表",
  title69: "至",
  title70: "至",
  title71: "空气质量指数",

  title102: "Nehezen szárad",
  title103: "Lassú száradás",
  title104: "Jól szárad",
  title105: "Gyors száradás",
  title106: "Nagyon gyors száradás",

  title107: "Nem alkalmas",
  title108: "Szolid élmény",
  title109: "Jó vízi szórakozáshoz",
  title110: "Nagyon alkalmas",
  title111: "Tökéletes körülmények",

  title112: "Támogató az egészségnek",
  title113: "Semleges körülmények",
  title114: "Enyhén magasabb kockázat",
  title115: "Magas kockázat",
  title116: "Extrém kockázat",

  title117: "Nem alkalmas",
  title118: "Részben alkalmas",
  title119: "Jó szabadtéri tevékenységhez",
  title120: "Nagyon alkalmas",
  title121: "Kiváló körülmények",

  title122: "Nagyon száraz körülmények",
  title123: "Valószínűleg száraz",
  title124: "Enyhén száraz",
  title125: "Nem valószínű, hogy száraz",
  title126: "Nagyon nem valószínű, hogy száraz",

  title127: "Nem ajánlott",
  title128: "Elfogadható",
  title129: "Jó nap",
  title130: "Nagyon jó körülmények",
  title131: "Ideális körülmények",
};
